import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTable20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTable20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 3.5h13c.551 0 1 .448 1 1.002V5.5h-15v-1a1 1 0 0 1 1-1M1 7V4.5A2.5 2.5 0 0 1 3.5 2h13C17.88 2 19 3.121 19 4.502v10.496a2.5 2.5 0 0 1-2.5 2.502h-13A2.5 2.5 0 0 1 1 15zm1.5 7v1a1 1 0 0 0 1 1h3v-2zm9.5 2H8v-2h4zm1.5 0h3c.551 0 1-.448 1-1.002V14h-4zm0-3.5h4v-2h-4zm-1.5-2H8v2h4zM12 9H8V7h4zm1.5 0h4V7h-4zm-7 0V7h-4v2zm0 3.5v-2h-4v2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTable20);
